import { render, staticRenderFns } from "./DefaultPenalties.vue?vue&type=template&id=17b8515b"
import script from "./DefaultPenalties.vue?vue&type=script&lang=js"
export * from "./DefaultPenalties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports